import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/home'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'
    import bumenxinxi from '@/views/modules/bumenxinxi/list'
    import yuangong from '@/views/modules/yuangong/list'
    import yuangongRegister from '@/views/modules/yuangongRegister/list'
    import yuangonggongzi from '@/views/modules/yuangonggongzi/list'
    import qingjiashenqing from '@/views/modules/qingjiashenqing/list'
    import diaodongshenqing from '@/views/modules/diaodongshenqing/list'
    import jiabanshenqing from '@/views/modules/jiabanshenqing/list'
    import shangbandaka from '@/views/modules/shangbandaka/list'
    import config from '@/views/modules/config/list'
    import gongsigonggao from '@/views/modules/gongsigonggao/list'
    import yuangongkaoqin from '@/views/modules/yuangongkaoqin/list'
    import articleCategory from '@/views/modules/article-category/list'
    import article from '@/views/modules/article/list'
    import noticeBar from '@/views/modules/notice-bar/list'
    import functionGrid from '@/views/modules/function-grid/list'
    import gongzuojilu from '@/views/modules/gongzuojilu/list'
    import cepingJieguo from '@/views/modules/cepingJieguo/list'
    import yuangongShebao from '@/views/modules/yuangongShebao/list'
    import recruitment from '@/views/modules/recruitment/list'
    import hetong from '@/views/modules/hetong/list'


//2.配置路由   注意：名字
export const routes = [{
    path: '/',
    name: '系统首页',
    component: Index,
    children: [{
      // 这里不设置值，是把main作为默认页面
      path: '/',
      name: '系统首页',
      component: Home,
      meta: {icon:'', title:'center', affix: true}
    }, {
      path: '/updatePassword',
      name: '修改密码',
      component: UpdatePassword,
      meta: {icon:'', title:'updatePassword'}
    }, {
      path: '/pay',
      name: '支付',
      component: pay,
      meta: {icon:'', title:'pay'}
    }, {
      path: '/center',
      name: '个人信息',
      component: center,
      meta: {icon:'', title:'center'}
    }
      ,{
	path: '/bumenxinxi',
        name: '部门信息',
        component: bumenxinxi
      }
      ,{
	path: '/yuangong',
        name: '员工',
        component: yuangong
      }
      ,{
	path: '/yuangongRegister',
        name: '员工注册审核',
        component: yuangongRegister
      }
      ,{
	path: '/yuangonggongzi',
        name: '员工工资',
        component: yuangonggongzi
      }
      ,{
	path: '/yuangongShebao',
        name: '员工社保',
        component: yuangongShebao
      }
      ,{
	path: '/qingjiashenqing',
        name: '请假申请',
        component: qingjiashenqing
      }
      ,{
	path: '/diaodongshenqing',
        name: '调动申请',
        component: diaodongshenqing
      }
      ,{
	path: '/jiabanshenqing',
        name: '加班申请',
        component: jiabanshenqing
      }
      ,{
	path: '/shangbandaka',
        name: '上班打卡',
        component: shangbandaka
      }
      ,{
	path: '/config',
        name: '轮播图管理',
        component: config
      }
      ,{
	path: '/gongzuojilu',
        name: '工作记录',
        component: gongzuojilu
      }
      ,{
	path: '/cepingJieguo',
        name: '测评管理',
        component: cepingJieguo
      }
      ,{
	path: '/gongsigonggao',
        name: '公司公告',
        component: gongsigonggao
      }
      ,{
	path: '/yuangongkaoqin',
        name: '员工考勤',
        component: yuangongkaoqin
      }
      ,{
	path: '/article-category',
        name: '文章分类',
        component: articleCategory
      }
      ,{
	path: '/article',
        name: '文章资讯',
        component: article
      }
      ,{
	path: '/notice-bar',
        name: '公告栏管理',
        component: noticeBar
      }
      ,{
	path: '/function-grid',
        name: '导航管理',
        component: functionGrid
      }
      ,{
	path: '/recruitment',
        name: '残友招聘管理',
        component: recruitment
      }
      ,{
	path: '/hetong',
        name: '合同管理',
        component: hetong
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {icon:'', title:'login'}
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {icon:'', title:'register'}
  },
  {
    path: '*',
    component: NotFound
  }
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
  mode: 'hash',
  /*hash模式改为history*/
  routes // （缩写）相当于 routes: routes
})
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default router;
